import React, { useContext, useEffect, useState } from "react";
import "../../../assests/css/studentdashboard/StudentRegister.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";

const StudentRegister = () => {
  const { baseUrl, setAuthToken, setLoggedInStudent } = useContext(AppContext);
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [programme, setProgramme] = useState("");
  const [semester, setSemester] = useState("");
  const [sessionStart, setSessionStart] = useState("");
  const [rollNumber, setRollNumber] = useState("");
  const [ngprogramme, setNgprogramme] = useState([]);
  const [registerLoading, setRegisterLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();
  const sessions = [2022, 2023, 2024, 2025, 2026, 2027];

const validateEmail = (value) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const viewAllProgrammeForSignup = () => {
    axios
      .get(`${baseUrl}/student/programme/viewAllProgrammeForSignup`)
      .then((response) => {
        setNgprogramme(response.data.ngprogrammes);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const studentReg = (e) => {
    e.preventDefault();
    setErrorMessage("");

    // ---- Frontend validation ----
    if (
      !fullname ||
      !email ||
      !password ||
      !programme ||
      !semester ||
      !sessionStart ||
      !rollNumber
    ) {
      setErrorMessage("Please fill all fields.");
      return;
    }
    if (!validateEmail(email)) {
      setErrorMessage("Please enter a valid email address.");
      return;
    }
    if (password.length < 6) {
      setErrorMessage("Password must be at least 6 characters.");
      return;
    }
    if (Number(semester) < 1 || Number(semester) > 8) {
      setErrorMessage("Semester must be between 1 and 8.");
      return;
    }
    if (Number(rollNumber) < 1 || Number(rollNumber) > 200) {
      setErrorMessage("Roll number must be between 1 and 200.");
      return;
    }

    setRegisterLoading(true);

    const formData = new FormData();
    formData.append("fullname", fullname);
    formData.append("email", email);
    formData.append("password", password);
    formData.append("ngprogramme_id", programme);
    formData.append("semester", semester);
    formData.append("session", sessionStart);
    formData.append("roll_number", rollNumber);

    axios
      .post(`${baseUrl}/student/auth/studentRegister`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        if (response.data.success === true) {
          // JWT token save
          localStorage.setItem("authToken", response.data.token);

          // AppContext mein token save
          setAuthToken(response.data.token);

          // Student data save in AppContext
          setLoggedInStudent(response.data.student);

          // Student data save in localStorage
          localStorage.setItem(
            "student",
            JSON.stringify(response.data.student),
          );

          // Form clear
          setFullname("");
          setEmail("");
          setPassword("");
          setProgramme("");
          setSemester("");
          setSessionStart("");
          setRollNumber("");

          // Direct dashboard
          navigate("/student/dashboard");
        } else {
          setErrorMessage(
            response.data.message || "Registration failed. Try again.",
          );
        }
      })
      .catch((error) => {
        console.log(error);
        setErrorMessage(
          error.response?.data?.message ||
            "Something went wrong. Please try again.",
        );
      })
      .finally(() => {
        setRegisterLoading(false);
      });
  };

  useEffect(() => {
    viewAllProgrammeForSignup();
  }, []);

  return (
    <div className="sr-container">
      <div className="sr-card">
        <div className="sr-header">
          <div className="sr-icon">🎓</div>
          <h2 className="sr-title">Student Register</h2>
          <p className="sr-subtitle">Create your student account</p>
        </div>

        {errorMessage && (
          <p className="sr-error" style={{ color: "red" }}>
            {errorMessage}
          </p>
        )}

        <form className="sr-form" onSubmit={studentReg}>
          <div className="sr-row">
            <div className="sr-field">
              <input
                type="text"
                name="fullname"
                placeholder="Full Name"
                value={fullname}
                onChange={(event) => setFullname(event.target.value)}
              />
            </div>

            <div className="sr-field">
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </div>
          </div>

          <div className="sr-field">
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>

          <div className="sr-field">
            <select
              name="programme"
              value={programme}
              onChange={(event) => setProgramme(event.target.value)}
            >
              <option value="">Select Program</option>
              {ngprogramme.map((singleProgram) => (
                <option key={singleProgram.id} value={singleProgram.id}>
                  {singleProgram.progName}
                </option>
              ))}
            </select>
          </div>
          <div className="sr-field">
            <select
              name="session"
              value={sessionStart}
              onChange={(event) => setSessionStart(event.target.value)}
            >
              <option value="">Select Session</option>

              {sessions.map((year) => {
                const endYear = String(Number(year) + 4).slice(-2);

                return (
                  <option key={year} value={year}>
                    {year}-{endYear}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="sr-field">
            <select
              name="semester"
              value={semester}
              onChange={(event) => setSemester(event.target.value)}
            >
              <option value="">Select Semester</option>
              <option value="1">1st Semester</option>
              <option value="2">2nd Semester</option>
              <option value="3">3rd Semester</option>
              <option value="4">4th Semester</option>
              <option value="5">5th Semester</option>
              <option value="6">6th Semester</option>
              <option value="7">7th Semester</option>
              <option value="8">8th Semester</option>
            </select>
          </div>

        <div className="sr-field">
  <input
    type="number"
    name="roll_number"
    placeholder="Roll Number (1-200)"
    value={rollNumber}
    min="1"
    max="200"
    onChange={(event) => setRollNumber(event.target.value)}
  />
</div>

          <button className="sr-btn" type="submit" disabled={registerLoading}>
            {registerLoading ? "REGISTERING..." : "REGISTER"}
          </button>

          <p className="sr-login-text">
            Already have an account?{" "}
            <span onClick={() => navigate("/student-login")}>Login</span>
          </p>
        </form>
      </div>
    </div>
  );
};

export default StudentRegister;
